var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "iframeContainer" },
    [
      _vm.iframeLoading
        ? _c(
            "div",
            [
              _c("md-progress-spinner", {
                staticClass: "md-accent",
                attrs: { "md-stroke": 3, "md-mode": "indeterminate" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getCustomerClientAddress()
        ? _c("iframe", {
            staticClass: "mt-2",
            staticStyle: { height: "500px" },
            attrs: {
              sandbox:
                "allow-forms allow-top-navigation allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-scripts",
              frameborder: "0",
              loading: "eager",
              src: _vm.getCustomerClientAddress(),
            },
            on: {
              load: function ($event) {
                _vm.iframeLoading = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("BubblePreview", { staticClass: "message-baloon" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }